/* The Sanctum bearer token. Kept in localStorage so a session survives reloads; the user object
   itself is never stored, it is always fetched fresh from /api/me. */
const STORAGE_KEY = "estate.token";

let memoryToken: string | null = null;

export function readToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? memoryToken;
  } catch {
    return memoryToken;
  }
}

export function writeToken(token: string | null): void {
  memoryToken = token;
  try {
    if (token === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Private browsing can block storage; the in-memory copy keeps this visit signed in.
  }
}

type Listener = () => void;
const expiryListeners = new Set<Listener>();

/** Called by the HTTP layer when the server rejects the token (401). */
export function notifySessionExpired(): void {
  writeToken(null);
  for (const listener of expiryListeners) listener();
}

export function onSessionExpired(listener: Listener): () => void {
  expiryListeners.add(listener);
  return () => expiryListeners.delete(listener);
}
